type tOptionFormData<T extends string> = { label: string; value: T } | null;

export const mapEntityArrayToFormOptions = <T extends string>(
  value: T[] | undefined,
  options: tOptionFormData<T>[],
): tOptionFormData<T>[] => {
  const result: tOptionFormData<T>[] = [];

  if (!value) return [];

  for (const valueItem of value) {
    const maybeOption = options.find((option) => option?.value === valueItem);
    if (!maybeOption) continue;
    result.push(maybeOption);
  }

  return result;
};

export const mapFormOptionsToEntityArray = <T extends string>(value: tOptionFormData<T>[]): T[] | undefined => {
  const result: T[] = [];

  for (const valueItem of value) {
    if (valueItem?.value) result.push(valueItem.value);
  }

  return result;
};
